import { render, staticRenderFns } from "./CreateEnrolment.vue?vue&type=template&id=eefc086c&scoped=true&"
import script from "./CreateEnrolment.vue?vue&type=script&lang=js&"
export * from "./CreateEnrolment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefc086c",
  null
  
)

export default component.exports